const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Endpoints = {
  auth: {
    login: `${BASE_URL}/auth/login`,
    register: `${BASE_URL}/auth/register`,
    logout: `${BASE_URL}/auth/logout`,
    verify: `${BASE_URL}/auth/verify`,
    resend: `${BASE_URL}/auth/resend`,
    refreshtoken: `${BASE_URL}/auth/refreshtoken`,
    updatePassword: `${BASE_URL}/auth/updatePassword`,
    resetPassword: `${BASE_URL}/auth/resetPassword`,
  },
  users: {
    getAll: `${BASE_URL}/api/user/allusers`,
  },
  user: {
    get: `${BASE_URL}/api/user/{userId}`,
    profile: `${BASE_URL}/api/user/profile/{userId}`,
    update: {
      user: `${BASE_URL}/api/user/user/update`,
      profile: `${BASE_URL}/api/user/profile/update`
    },
    me: `${BASE_URL}/api/user/me`,
    getById: `${BASE_URL}/api/user/profile/`,
    //getMatches: `${BASE_URL}/api/match/find`, //deprecated
    matches: {
      initial: `${BASE_URL}/api/match/initial`,
      search: `${BASE_URL}/api/match/search`,
      filter: `${BASE_URL}/api/match/filter`,
    },
    getLikesSent: `${BASE_URL}/api/likes/sent`,
    getLikesReceived: `${BASE_URL}/api/likes/received`,
    saveLocation: `${BASE_URL}/api/location/userLocationCoordinates`,
    images: {
      upload: {
        galleryImage: `${BASE_URL}/api/user/upload/galleryImage`,
        profileImage: `${BASE_URL}/api/user/upload/profileImage`
      },
      delete: {
        galleryImage: `${BASE_URL}/api/user/delete/galleryImage`,
        profileImage: `${BASE_URL}/api/user/delete/profileImage`
      },
      promoteGalleryImage: `${BASE_URL}/api/user/promoteGalleryImage`,
      getAll: `${BASE_URL}/api/user/imagesAll/{userId}`,
      getByType: `${BASE_URL}/api/user/imageByTyp/{userId}`,
    }
  },
  posts: {
    list: `${BASE_URL}/posts`,
    detail: (id) => `${BASE_URL}/posts/${id}`,
    create: `${BASE_URL}/posts/create`,
    delete: (id) => `${BASE_URL}/posts/${id}/delete`,
  },
  api: {
    locationSave: `${BASE_URL}/api/location/userLocationCoordinates`,
  },
  onboarding: {
    progress: `${BASE_URL}/api/onboarding/totalProgress/{userProfileId}`,
    completeStep: `${BASE_URL}/api/onboarding/completeStep`,
    question: {
      get: {
        random: `${BASE_URL}/api/onboarding/questions/random?userProfileId={userProfileId}`,
      }
    },
    answer: {
      save: `${BASE_URL}/api/onboarding/answer/save`
    }
  },
  cookies: {
    get: `${BASE_URL}/api/consent/cookies`,
    post: `${BASE_URL}/api/consent/cookies`
  }
};

export default Endpoints;